import { ExpressionRuleEditor } from "../ExpressionRuleEditor";
import { GroupedBracketedDiv } from "../Logic/AndGroupEditor";
import { ExpressionPiece } from "../../Builder/ExpressionStyles";
import React from "react";
import { RandomExpression } from "../../../rule-engine-core/Expressions/Expressions/Math/RandomExpression";

export class RandomExpressionEditor extends ExpressionRuleEditor<RandomExpression> {
    render() {
        return (
            <GroupedBracketedDiv issue={this.ruleData!.getValidationIssues()[0]}>
                <ExpressionPiece>Random Number</ExpressionPiece>
            </GroupedBracketedDiv>
        );
    }
}
